export default __webpack_public_path__ + "static/media/fonts/alegreyasans-regular-webfont.caa20a4a.woff2";